import axios from "axios";
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
let store = null;
export const buildStore = () => {
    // Create browser history to use in the Redux store
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
    const history = createBrowserHistory({ basename: baseUrl });

    // Get the application-wide store instance, prepopulating with state from the server where available.
    store = configureStore(history);
    return {store,history};
}

export const getStore = () => {
    return store;
};

export const OfflineEffect = (effect, _action) => {
    return axios(effect);
};
export const OfflineDiscard = (error, _action, _retries) => {
    console.log("online call !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
    const { request, response } = error;
    if (!request) throw error; // There was an error creating the request
    if (!response) return false; // There was no response
    return 400 <= response.status && response.status < 500;
}
